import React from "react";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import { format } from "../../components/text-helper/text-helper";
import HighlightedText from "./HighlightedText";
import "./Search.scss";
import { Compilation } from "../../types/Compilation";

interface CompilationSearchResultProps {
    index: number;
    searchText: string;
    compilation: Compilation;
}

const CompilationSearchResult = (props: CompilationSearchResultProps) => {
    return (
        <Box component={Link}
            className="search-result"
            key={`$album-${props.index}`}
            to={`/compilations/${props.compilation.directory}/albums/${props.compilation.year} - ${props.compilation.title}`}
        >
            <HighlightedText searchText={props.searchText} term={props.compilation.title} />
            in {format(props.compilation.directory)} ({props.compilation.year})
        </Box>
    );
}

export default CompilationSearchResult;